<div class="modal-container">
  <!-- Header -->
  <div class="modal-header">
    <h2 [ngClass]="{ 'category-margin': mode === 'category' }" *ngIf="mode === 'category'">
      {{ (isEditMode ? "update_category" : "create_category") | translate }}
    </h2>
    <h2 *ngIf="mode === 'images'">
      {{ "add_pictogram_images_title" | translate }}
    </h2>
     <img class="close-icon" tooltip="{{'Close' | translate }}" alt="" placement="bottom" (click)="close()" src="assets/icon/cancel.svg">

  </div>

  <!-- BODY -->
  <div class="modal-body">
    <!-- CATEGORY MODE -->
    <ng-container *ngIf="mode === 'category'">
      <div class="cat-name">
        <div class="full-row">
          <ion-label class="label-cat-name">{{
            "category_name" | translate
            }}</ion-label>
          <ion-item lines="none" color="--ion-color-primary-contrast" class="cat-item">
            <ion-input name="addcategory" placeholder="{{ 'enter_category_name' | translate }}"
              [(ngModel)]="categoryName" #categoryname="ngModel">
            </ion-input>
          </ion-item>
          <div class="validation-messages">
            <ion-text *ngIf="categoryname.invalid && categoryname.touched" color="danger">
              {{ "required" | translate }}
            </ion-text>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- IMAGE MODE -->
    <ng-container *ngIf="mode === 'images'">
      <!-- Dropdown -->

      <ion-label class="label-cat-select">{{
        "category_name" | translate
        }}</ion-label>
      <div class="custom-select-wrapper">
        <ng-select class="custom-ng-select" [placeholder]="'Select Category' | translate" [items]="categories" bindLabel="name"
          [(ngModel)]="selectedCategory">
        </ng-select>
      </div>

      <!-- Drag & Drop -->
      <app-image-upload
        class="upload-box-shared"
        [width]="'100%'"
        [height]="'180px'"
        [multiple]="true"
        [maxFiles]="10"
        [maxFileSize]="5242880"
        [accept]="'.jpg,.jpeg,.gif,.png,.webp,.bmp,.tga,image/jpeg,image/jpg,image/gif,image/png,image/webp,image/bmp'"
        [placeholder]="'drag_and_upload_images'"
        [disabled]="!selectedCategory"
        [disabledMessage]="'please_select_category' | translate"
        (filesSelected)="onPictogramImagesSelected($event)"
      ></app-image-upload>

      <div class="file-preview" *ngIf="totalFiles > 0">
        <div class="file-details">
          <span class="file-icon">
            <img src="assets/icon/clip.svg" alt="" />
          </span>

          <!-- COUNT TEXT -->
          <span class="file-name">
            {{ uploadedCount }} {{ "out_of" | translate }} {{ totalFiles }}
            {{ "uploaded" | translate }}
          </span>
        </div>

        <!-- PROGRESS BAR -->
        <div class="progress-bar-container">
          <div class="progress-bar" [style.width]="uploadProgress + '%'"></div>
        </div>
        <div class="failed-files" *ngIf="failedFiles?.length > 0">
          <p class="error-text">{{ "failed_uploads" | translate }}:</p>
          <div *ngFor="let file of failedFiles" class="failed-item">
            {{ file }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
     
    <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="close()">
      {{ "Cancel" | translate }}
    </ion-button>

    <ion-button *ngIf="!isEditMode" class="app-btn" shape="round" fill="outline" color="primary" (click)="submit()">
      {{ (mode === "category" ? "create_category" : "Confirm") | translate }}
    </ion-button>

    <ion-button *ngIf="isEditMode" class="app-btn" shape="round" fill="outline" color="primary"
      (click)="updateCategory()">
      {{ "update_category" | translate }}
    </ion-button>
  </div>
</div>